const CURRENT_VERSION = process.env.VUE_APP_BUILD_TIME || '0';

class VersionCheckService {
    private intervalId: number | null = null;

    start(onNewVersion: () => void, intervalMs = 5 * 60 * 1000) {
        if (!CURRENT_VERSION || CURRENT_VERSION === '0') return;
        this.intervalId = window.setInterval(async () => {
            try {
                const res = await fetch('/version.json?_=' + Date.now(), { cache: 'no-store' });
                if (!res.ok) return;
                const data = await res.json();
                if (data.version && data.version !== CURRENT_VERSION) {
                    onNewVersion();
                    this.stop();
                }
            } catch { /* red caída, ignorar */ }
        }, intervalMs);
    }

    stop() {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

export const versionCheckService = new VersionCheckService();
